<template>
  <div>
    <v-card>
      <v-card-title>
        <v-icon color="primary"> mdi-cog </v-icon>
        <span class="pl-2">{{ $t('ops.settings.title') }}</span>
      </v-card-title>
      <v-card-text>
        <vue-element-loading :active="isLoading" />
        <v-form ref="form" v-if="settings" v-model="valid" lazy-validation class="my-2">
          <div class="my-4">
            <label class="text--secondary font-weight-bold">{{ $t('ops.settings.generalSettings') }}</label>
          </div>
          <v-row>
            <v-col cols="12" md="4" class="my-2">
              <v-autocomplete
                v-model="selectedCurrency"
                :items="currencies"
                dense
                outlined
                item-text="name"
                item-value="id"
                :label="$t('ops.settings.currencyLabel')"
                :filter="customFilter"
                persistent-hint
                return-object
                required
                :rules="requiredRules"
                :hint="
                  selectedCurrency != null
                    ? selectedCurrency.code + ' (' + selectedCurrency.symbol + ')'
                    : ''
                "
                @change="currencySelected"
              ></v-autocomplete>
            </v-col>
            <!-- distance_to_stop_to_mark_arrived -->
            <v-col cols="12" md="4" class="my-2">
                <v-text-field
                  v-model="settings.distance_to_stop_to_mark_arrived"
                  type="number"
                  outlined
                  dense
                  :label="$t('ops.settings.distanceToStopLabel')"
                  :placeholder="$t('ops.settings.distanceToStopPlaceholder')"
                  persistent-hint
                  required
                  :rules="numberRules"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="my-2">
                <v-text-field
                  v-model="settings.max_search_radius"
                  type="number"
                  outlined
                  dense
                  :label="$t('ops.settings.searchRadiusLabel')"
                  :placeholder="$t('ops.settings.searchRadiusPlaceholder')"
                  persistent-hint
                  required
                  :rules="numberRules"
                ></v-text-field>
            </v-col>
          </v-row>
          <div class="my-4">
            <label class="text--secondary font-weight-bold">{{ $t('ops.settings.driverAnnouncementSettings') }}</label>
          </div>
          <v-row>
            <v-col cols="12" md="4" class="my-2">
                <v-text-field
                  v-model="settings.distance_to_drop_off"
                  type="number"
                  outlined
                  dense
                  :label="$t('ops.settings.distanceDropOffLabel')"
                  :placeholder="$t('ops.settings.distanceDropOffPlaceholder')"
                  persistent-hint
                  required
                  :rules="numberRules"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="my-2">
                <v-text-field
                  v-model="settings.distance_to_pick_up"
                  type="number"
                  outlined
                  dense
                  :label="$t('ops.settings.distancePickUpLabel')"
                  :placeholder="$t('ops.settings.distancePickUpPlaceholder')"
                  persistent-hint
                  required
                  :rules="numberRules"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="my-2">
                <v-text-field
                  v-model="settings.distance_to_slow_down"
                  type="number"
                  outlined
                  dense
                  :label="$t('ops.settings.distanceSlowDownLabel')"
                  :placeholder="$t('ops.settings.distanceSlowDownPlaceholder')"
                  persistent-hint
                  required
                  :rules="numberRules"
                ></v-text-field>
            </v-col>
          </v-row>
          <div class="mt-8">
            <label class="text--secondary font-weight-bold">{{ $t('ops.settings.adminInformation') }}
                <info-tool-tip class="ml-2"
            :message="$t('ops.settings.adminInformationTooltip')"></info-tool-tip>
            </label>
          </div>
          <v-row class="my-2">
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="settings.admin_email"
                    outlined
                    dense
                    :label="$t('ops.settings.adminEmailLabel')"
                    :placeholder="$t('ops.settings.adminEmailPlaceholder')"
                    persistent-hint
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="settings.admin_phone"
                    outlined
                    dense
                    :label="$t('ops.settings.adminPhoneLabel')"
                    :placeholder="$t('ops.settings.adminPhonePlaceholder')"
                    persistent-hint
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="settings.admin_address"
                    outlined
                    dense
                    :label="$t('ops.settings.adminAddressLabel')"
                    :placeholder="$t('ops.settings.adminAddressPlaceholder')"
                    persistent-hint
                ></v-text-field>
            </v-col>
          </v-row>
          <div class="mt-8">
            <label class="text--secondary font-weight-bold">{{ $t('ops.settings.allowOtpSetting') }}             <info-tool-tip class="ml-2"
            :message="$t('ops.settings.allowOtpTooltip')"></info-tool-tip></label>
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <v-checkbox
                v-model="settings.otp_required"
                :label="$t('ops.settings.allowOtpCheckbox')"
                persistent-hint
              ></v-checkbox>
            </v-col>
          </v-row>
          <div class="mt-8">
            <label class="text--secondary font-weight-bold">{{ $t('ops.settings.hidePaymentSetting') }}             <info-tool-tip class="ml-2"
            :message="$t('ops.settings.hidePaymentTooltip')"></info-tool-tip></label>
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <v-checkbox
                v-model="settings.hide_payment_parents"
                :label="$t('ops.settings.hidePaymentCheckbox')"
                persistent-hint
              ></v-checkbox>
            </v-col>
          </v-row>
          <div class="mt-8">
            <label class="text--secondary font-weight-bold">{{ $t('ops.settings.hideSchoolsSetting') }}             <info-tool-tip class="ml-2"
            :message="$t('ops.settings.hideSchoolsTooltip')"></info-tool-tip></label>
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <v-checkbox
                v-model="settings.hide_schools"
                :label="$t('ops.settings.hideSchoolsCheckbox')"
                persistent-hint
              ></v-checkbox>
            </v-col>
          </v-row>
          <div class="mt-8">
            <label class="text--secondary font-weight-bold">{{ $t('ops.settings.modeSetting') }}             <info-tool-tip class="ml-2"
            :message="$t('ops.settings.modeTooltip')"></info-tool-tip></label>
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <v-checkbox
                v-model="settings.simple_mode"
                :label="$t('ops.settings.simpleModeCheckbox')"
                persistent-hint
              ></v-checkbox>
            </v-col>
          </v-row>
          <div class="mt-8">
            <label class="text--secondary font-weight-bold">{{ $t('ops.settings.adsSetting') }} <info-tool-tip class="ml-2"
            :message="$t('ops.settings.adsTooltip')"> </info-tool-tip></label>
          </div>
          <v-row>
            <v-col cols="12" md="6">
              <v-checkbox
                v-model="settings.allow_ads_in_driver_app"
                :label="$t('ops.settings.allowAdsDriverCheckbox')"
                persistent-hint
              ></v-checkbox>
              <v-checkbox
                v-model="settings.allow_ads_in_parent_app"
                :label="$t('ops.settings.allowAdsParentCheckbox')"
                persistent-hint
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn :disabled="!valid" color="primary" @click="saveSettings">
            {{ $t('common.save') }}
            <v-icon right dark> mdi-content-save </v-icon>
          </v-btn>
        </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import InfoToolTip from "@/components/InfoToolTip";
import VueElementLoading from "vue-element-loading";
import auth from '@/services/AuthService'
export default {
  components: {
    VueElementLoading,
    InfoToolTip
  },
  data() {
    return {
      currencies: [],
      isLoading: false,
      settings: null,
      valid: true,
      selectedCurrency: null,
    };
  },
  computed: {
    requiredRules() {
      return [(v) => !!v || this.$t('ops.settings.requiredRule')];
    },
    numberRules() {
      return [(v) => /^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/.test(v) || this.$t('ops.settings.numberRule')];
    },
    percentRules() {
      return [(v) => /^100$|^[0-9]{1,2}$|^[0-9]{1,2}\,[0-9]{1,3}$/.test(v) || this.$t('ops.settings.percentRule')];
    },
  },
  mounted() {
    this.loadSettings();
  },
  methods: {
    customFilter (item, queryText, itemText) {
      const textOne = item.name.toLowerCase()
      const textTwo = item.code.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1
    },
    //API Calls
    saveSettings() {
      this.submiting = true;
      axios
        .post("/settings/update", this.settings)
        .then((response) => {
          this.submiting = false;
          this.$notify({
            title: this.$t('common.success'),
            text: this.$t('ops.settings.updated'),
            type: "success",
          });
        })
        .catch((error) => {
          this.submiting = false;
          this.$notify({
            title: this.$t('common.error'),
            text: this.$t('ops.settings.updateError'),
            type: "error",
          });
          console.log(error);
        });
    },
    loadSettings() {
      this.isLoading = true;
      this.settings = [];
      axios
        .get(`/settings/all`)
        .then((response) => {
          this.settings = response.data;
          this.loadCurrencies();
          this.selectedCurrency = this.settings.currency;
        })
        .catch((error) => {
          this.$notify({
            title: this.$t('common.error'),
            text: this.$t('ops.settings.fetchError'),
            type: "error",
          });
          console.log(error);
          auth.checkError(error.response.data.message, this.$router, this.$swal);
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    loadCurrencies() {
      this.isLoading = true;
      this.currencies = [];
      axios
        .get(`/currencies/all`)
        .then((response) => {
          this.currencies = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: this.$t('common.error'),
            text: this.$t('ops.settings.fetchCurrenciesError'),
            type: "error",
          });
          console.log(error);
          this.$swal(this.$t('common.error'), error.response.data.message, "error");
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    validate() {
      this.valid = false;
      let v = this.$refs.form.validate();
      if (v) {
        this.valid = true;
        return true;
      }
      return false;
    },
    currencySelected(r) {
      this.selectedCurrency = r;
      this.settings.currency_id = this.selectedCurrency.id;
    },
  },
};
</script>
